import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImagePresentationProps, LazyImageProps } from "@insite/mobius/LazyImage";
import LazyImagePresentationPropsDefault from "@insite/mobius/LazyImage/presentationProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    image = "image",
    buttonLabel = "buttonLabel",
    buttonLink = "buttonLink",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.buttonLabel]: string;
        [fields.buttonLink]: string;
    };
}

export interface CustomMenuStyle {
    menuContainer?: InjectableCss;
    imageContainer?: LazyImageProps;
    menuImage?: LazyImageProps;
    menuImageLink?: LinkPresentationProps;
}

export const customMenuStyle: CustomMenuStyle = {
    menuImage: {
        css: css`
            img {
                aspect-ratio: 3.32/2.86;
            }
        `,
    },
    menuContainer: {
        css: css``,
    },
    imageContainer: {
        css: css`
            position: relative;
        `,
    },
    menuImageLink: {
        css: css`
            position: absolute;
            top: 85px;
            left: 70px;
            background: ${getColor("primary")};
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            padding: 12px 40px;
            span {
                color: ${getColor("primary.contrast")} !important;
            }
        `,
    },
};

const styles = customMenuStyle;

export const SurCustomMenu: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.menuContainer}>
            <StyledWrapper {...styles.imageContainer}>
                <LazyImage {...styles.menuImage} src={fields.image} />
                <Link href={fields.buttonLink} {...styles.menuImageLink}>
                    {fields.buttonLabel}
                </Link>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SurCustomMenu,
    definition: {
        group: "Basic",
        displayName: "Custom Menu",
        fieldDefinitions: [
            {
                name: fields.image,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                name: fields.buttonLabel,
                fieldType: "General",
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                name: fields.buttonLink,
                fieldType: "General",
                displayName: "Button Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
            },
        ],
    },
};

export default widgetModule;
